<template>
    <div id="footer">
        <div class="container">
            <li v-for="(item, i) in fooList" :key="i">
                {{item.el}}
            </li>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            fooList: [
                { el : `제 31회 건국대학교 시각광고디자인과 졸업전시회` },
                { el : `건국대 시각광고디자인학과 043-840-3634` },
            ],
        }
    },
}
</script>

<style scoped>
@media all and (max-width: 767px ) {
    #footer {
        display: none;
    }
    /* #footer, .container {
        width: 100vw;
        height: 40px;
        position: fixed;
        left: 0;
        bottom: 0;
        background: #000;
    }
    #footer {
        display: table;
    }
    #footer .container {
        display: table-cell;
        vertical-align: middle;
        text-align: right;
    }
    #footer .container li {
        display: block;
        list-style: none;
        padding: 0 4vw;
        margin: 4px auto;
        font-size: 0.7rem;
    } */
}  

@media all and (min-width: 768px) {
    #footer, .container {
        width: 100vw;
        height: 32px;
        position: fixed;
        bottom: 0;
        left: 0;
    }
    #footer {
        display: table;
    }
    #footer .container {
        display: table-cell;
        vertical-align: middle;
        text-align: right;
    }
    #footer .container li {
        display: inline-block;
        list-style: none;
        margin: 0 4vw 0 2vw;
        font-size: 0.8rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/AppFooter.vue